@if (downloading) {
  <button mat-stroked-button disabled class="exporting">
    <mat-icon>
      <mat-spinner [diameter]="18" [strokeWidth]="2.2"></mat-spinner>
    </mat-icon>
    Exporting ({{ exportingProgress$ | async }}%)
  </button>
} @else {
  <button mat-stroked-button (click)="export()">
    {{ selectedItems.length > 0 ? 'Export selected' : 'Export all' }}
    <mat-icon>publish</mat-icon>
  </button>
}
